import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';


import { SentaiLogoImage } from '../constants';

const Header = () => {

    return (
            <Navbar variant="dark" bg="black" fixed="top">
                <Container>
                    <Navbar.Brand className="text-uppercase text-green size-18 bold"
                        as={Link}
                        to="/">
                        <img id="logo" alt="sentai"
                            src={SentaiLogoImage}
                            className="d-inline-block align-top" />
                    </Navbar.Brand>
                </Container>
            </Navbar>
    );
}

export default Header;

